RivalIQ.apps.Overview.module('widgets', function (widgets, App, Backbone, Marionette, $, _, LazyLoad) {

    'use strict';

    const ObservationText = RivalIQ.views.ItemView.mixin({
        template: '#overviewCrossChannelInsightTemplate',

        serializeData: function () {
            const me = this;
            const channel = me.options.channel;
            const postName = RivalIQ.data.channels.get(channel).get('postName') || 'post';
            const icon = (channel === RivalIQ.enums.channels.YOUTUBE ? 'fa-youtube-play' : `fa-${channel}`);

            return {
                channel: channel,
                icon: icon,
                postName: postName,
                observationText: me.options.observation
            };
        }
    });

    const GridItem = RivalIQ.views.SocialPostGridItem.extend({
        getMetricData: function () {
            const me = this;
            const channel = me.getOption('channel');
            const data = me.options.metric.data;
            return data.dimensions[channel];
        }
    });

    const SingleChannelTopPost = RivalIQ.views.LayoutView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        regions: {
            postContainer: '.post-container',
            observationContainer: '.observation-container'
        },
        dashboardModelEvents: {
            'change:layout': 'reload'
        },
        template: '#overviewSingleChannelTopPostObservationTempate',

        onRenderLoaded: function () {
            const me = this;

            me.postContainer.show(new GridItem(me.options));
            me.observationContainer.show(new ObservationText({
                observation: me.options.observation,
                channel: me.options.channel
            }));
        }
    });

    const channelEnums = RivalIQ.enums.channels;
    const CrossChannelTopPosts = RivalIQ.views.LayoutView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        regions: {
            container: '.row'
        },
        ui: {},
        channels: [
            channelEnums.FACEBOOK,
            channelEnums.INSTAGRAM,
            channelEnums.TWITTER,
            channelEnums.YOUTUBE,
            channelEnums.TIKTOK
        ],
        dashboardModelEvents: {
            'change:layout': 'reload'
        },
        className: 'cross-channel-top-posts',
        template: '#overviewCrossChannelTopPostsTemplate',

        initialize: function () {
            const me = this;

            _.each(me.channels, function (channel) {
                const tag = ['.', channel, '-container'].join('');
                me.ui[channel] = tag;
                me.addRegion(channel, tag);
            });

            me.channelPostModels = {};
            me.observations = {};
        },

        loadData: function () {
            const me = this;

            const definition = me.getBaseMetric();

            const fetches = [
                definition.fetch(),
                RivalIQ.data.companyData.fetchPresences()
            ];

            return $.when.apply($, fetches)
                .then(function (metric, companyData) {
                    me.metric = metric;
                    const channelDimensions = metric.data.dimensions;

                    _.each(me.channels, function (channel) {
                        const channelData = channelDimensions[channel];
                        let post = _.get(channelData, ['dimensions', 'post', 'buckets']);
                        if (_.size(post)) {
                            post = _.values(post)[0];
                            me.channelPostModels[channel] = new RivalIQ.models.Post(post, {
                                companyData: companyData
                            });
                            me.observations[channel] = channelData.observation;
                        }
                    });
                });
        },

        getBaseMetric: function () {
            const me = this;
            const props = me.getProps();

            const definition = _.defaults({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
                dimensions: ['post'],
                property: 'post',
                orderBy: {
                    dimensions: ['post'],
                    property: 'engagement_total'
                },
                sortOrder: 1,
                limit: 1,
                channel: 'cross_channel',
                withObservations: true
            }, props);

            return new RivalIQ.models.MetricDefinition(definition);
        },

        canDisplayChannelPost: function (source, props) {
            const canDisplay = RivalIQ.state.account.channelDisplay(source);
            return canDisplay;
        },

        onRenderLoaded: function () {
            const me = this;

            // show sad graphs when there's no posts
            if (!_.size(me.channelPostModels)) {
                const EmptyView = RivalIQ.views.ItemView.extend({
                    template: '#overviewTopPostsEmptyPostsTemplate'
                });
                const focusCompany = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId')).get('name');
                me.container.show(new EmptyView({
                    model: new Backbone.Model({
                        message: `${focusCompany} did not publish any posts this period.`,
                        hideTryAgain: true
                    })
                }));

                return;
            }

            // display the bottom border between posts if more than one row
            const displayBottomBorder = _.size(me.channelPostModels) > 2;
            const maxIndexWithBorder = _.size(me.channelPostModels) === _.size(me.channels) ? 4 : 2;
            let postContainerIndex = 0;
            _.each(me.channels, function (channel) {
                const source = RivalIQ.enums.sources[channel.toUpperCase()];
                const canDisplay = me.canDisplayChannelPost(source, me.getProps());
                if (canDisplay && me.channelPostModels[channel]) {
                    me[channel].show(new SingleChannelTopPost({
                        metric: me.metric,
                        model: me.channelPostModels[channel],
                        dashboardModel: me.dashboardModel,
                        observation: me.observations[channel],
                        channel: channel
                    }));

                    if (displayBottomBorder && postContainerIndex < maxIndexWithBorder) {
                        me.ui[channel].addClass('bottom-border');
                    }
                    postContainerIndex++;
                } else {
                    me.ui[channel].addClass('x-no-posts');
                }
            });
        },

        onAttachLoaded: function () {
            const me = this;

            RivalIQ.apps.SocialPosts.utils.attachVideoOnLoadHandlers(me.$el);

            if (!me.dashboardModel.isExporting()) {
                if (me.lazyLoadInstance) {
                    me.lazyLoadInstance.destroy();
                }

                me.lazyLoadInstance = new LazyLoad({
                    elements_selector: '.lazy-load',
                    callback_error: function (el) {
                        const parent = $(el).parent();
                        parent.css('background-image', '');
                        parent.find('.no-video-thumbnail').removeClass('display-none');
                        parent.find('video').hide();
                    }
                });

                me.lazyLoadInstance.update();
            }
        }
    });

    const showImageLoadingToast = _.memoize(function (dashboardModel) {
        if (!dashboardModel.isExporting() && !dashboardModel.getProp('isInPostTagEditMode') && !dashboardModel.getProp('suppressBrokenImageNotifications')) {
            RivalIQ.execute('alert:info', RivalIQ.strings.social_posts_loading_broken_images);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsBrokenImageToast, {
                accountUserId: RivalIQ.state.user.get('id'),
                landscapeId: dashboardModel.getProp('landscapeId'),
                timePeriod: dashboardModel.getProp('timePeriod')
            });
        }
    }, function (dashboardModel) {
        let timePeriodStr = '';
        const timePeriod = dashboardModel.getProp('timePeriod');
        if (timePeriod) {
            // startOf day since some time periods have second components.
            timePeriodStr = [
                moment.utc(timePeriod.mainPeriodStart).startOf('day').toISOString(),
                moment.utc(timePeriod.mainPeriodEnd).startOf('day').toISOString()
            ].join(';');
        }
        return timePeriodStr;
    });

    const CrossChannelTopPostsWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({
        mixins: {
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },
        initialize: function () {
            const me = this;

            me.listenTo(me, 'brokenpostimage', function () {
                showImageLoadingToast(me);
            });

            RivalIQ.apps.Dashboard.models.Widget.prototype.initialize.apply(me, arguments);
        },
        view: CrossChannelTopPosts,
        getExportOrientation: function (format) {
            const me = this;
            const orientation = me.getProp('orientation');

            if (orientation) {
                return orientation;
            }

            return RivalIQ.enums.orientation.LANDSCAPE;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.OVERVIEW_CROSS_CHANNEL_TOP_POSTS, CrossChannelTopPostsWidget);
}, window.lazyload);
